import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { SAL2050_R01Dto } from "./Dto_SAL2050_R01";
import { SAL2050_R01Filter } from "./Store_SAL2050_R01";

const baseUrl = `${config.apiUrl}/SAL2050_R01`;

const getSearchParams = (params: Partial<SAL2050_R01Filter>) => {
	const salesYear = Number(params.salesYear);

	return {
		compCd: params.compCd || undefined,
		customCd: params.customCd || undefined,
		brandCd: params.brandCd || undefined,
		itemCd: params.itemCd || undefined,
		salesYear: Number.isFinite(salesYear) && salesYear > 0 ? salesYear : undefined,
	};
};

export const getSAL2050_R01Data = async (view: string, params: Partial<SAL2050_R01Filter>) => {
	const url = `${baseUrl}/search`;
	return await getData<ResponseDto<SAL2050_R01Dto[]>>(url, {
		params: {
			...getSearchParams(params),
			view,
		},
	});
};

export const exportSAL2050_R01Excel = async (view: string, params: Partial<SAL2050_R01Filter>) => {
	const url = `${baseUrl}/excel/search`;
	return await getData<ResponseDto<string>>(url, {
		params: {
			...getSearchParams(params),
			view,
		},
	});
};
